import { useState, useEffect } from "react";
import { Settings } from "lucide-react";
import { Card, Button, Seo } from "../../components";
import axios from "axios";
import { PROFILE_URL, CHANGE_PASSWORD_URL } from "../../features/UrlHelper";
import { handleApiError } from "../../features/errorHandler";
import "./ProfilePage.scss";

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${window.localStorage.getItem("authToken")}`,
  },
});

function SettingsSection() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [profileLoading, setProfileLoading] = useState(true);

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordChanging, setPasswordChanging] = useState(false);
  const [passwordMessage, setPasswordMessage] = useState("");
  const [passwordError, setPasswordError] = useState("");

  useEffect(() => {
    axios
      .get(PROFILE_URL, authHeaders())
      .then((res) => {
        setFirstName(res.data.firstName || "");
        setLastName(res.data.lastName || "");
        setEmail(res.data.email || "");
      })
      .catch((err) => handleApiError(err, "Nepodarilo sa načítať profil."))
      .finally(() => setProfileLoading(false));
  }, []);

  const handleChangePassword = (e) => {
    e.preventDefault();
    setPasswordError("");
    setPasswordMessage("");

    if (!currentPassword || !newPassword || !confirmPassword) {
      setPasswordError("Všetky polia sú povinné.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setPasswordError("Nové heslá sa nezhodujú.");
      return;
    }
    if (newPassword.length < 6) {
      setPasswordError("Nové heslo musí mať aspoň 6 znakov.");
      return;
    }

    setPasswordChanging(true);
    axios
      .post(
        CHANGE_PASSWORD_URL,
        { currentPassword, newPassword, newPasswordConfirm: confirmPassword },
        authHeaders()
      )
      .then((res) => {
        setPasswordMessage(res.data.message || "Heslo bolo úspešne zmenené.");
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      })
      .catch((err) => {
        const msg = handleApiError(err, "Chyba pri zmene hesla.");
        setPasswordError(msg);
      })
      .finally(() => setPasswordChanging(false));
  };

  if (profileLoading) {
    return (
      <div className="profile__section">
        <h2 className="profile__section-title">Nastavenia profilu</h2>
        <p>Načítavam...</p>
      </div>
    );
  }

  return (
    <div className="profile__section">
      <Seo title="Profil" noIndex={true} />
      <h2 className="profile__section-title">Nastavenia profilu</h2>

      <Card>
        <Card.Header>
          <Card.Title>Osobné údaje</Card.Title>
        </Card.Header>
        <Card.Body>
          <div className="profile__form">
            <div className="profile__form-row">
              <div className="profile__form-field">
                <label className="profile__form-label">Meno</label>
                <input
                  className="profile__form-input"
                  value={firstName}
                  disabled
                />
              </div>
              <div className="profile__form-field">
                <label className="profile__form-label">Priezvisko</label>
                <input
                  className="profile__form-input"
                  value={lastName}
                  disabled
                />
              </div>
            </div>
            <div className="profile__form-field">
              <label className="profile__form-label">Email</label>
              <input className="profile__form-input" value={email} disabled />
            </div>
          </div>
        </Card.Body>
      </Card>

      <Card>
        <Card.Header>
          <Card.Title>Zmena hesla</Card.Title>
        </Card.Header>
        <Card.Body>
          <form className="profile__form" onSubmit={handleChangePassword}>
            <div className="profile__form-field">
              <label className="profile__form-label">Aktuálne heslo</label>
              <input
                type="password"
                className="profile__form-input"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                placeholder="Zadajte aktuálne heslo"
              />
            </div>
            <div className="profile__form-row">
              <div className="profile__form-field">
                <label className="profile__form-label">Nové heslo</label>
                <input
                  type="password"
                  className="profile__form-input"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Min. 6 znakov"
                />
              </div>
              <div className="profile__form-field">
                <label className="profile__form-label">Potvrdenie hesla</label>
                <input
                  type="password"
                  className="profile__form-input"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Zopakujte nové heslo"
                />
              </div>
            </div>
            {passwordError && (
              <p className="profile__form-error">{passwordError}</p>
            )}
            {passwordMessage && (
              <p className="profile__form-success">{passwordMessage}</p>
            )}
            <div className="profile__form-actions">
              <Button
                type="submit"
                variant="primary"
                disabled={passwordChanging}
              >
                {passwordChanging ? "Mením heslo..." : "Zmeniť heslo"}
              </Button>
            </div>
          </form>
        </Card.Body>
      </Card>
    </div>
  );
}

// ─── Main component ──────────────────────────────

function ProfilePage() {
  return (
    <div className="profile">
      <main className="profile__content">
        <SettingsSection />
      </main>
    </div>
  );
}

export default ProfilePage;
